import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mc_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined") {
      const onAuthPage = ["/login", "/register"].includes(window.location.pathname);
      if (!onAuthPage) {
        localStorage.removeItem("mc_token");
        localStorage.removeItem("mc_user");
        localStorage.removeItem("mc_workspace");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
